import sanitizeHtml from 'sanitize-html';
import sanitizeHtmlOptions from '../config/sanitizeHtmlOptions';

export function sanitizeContentHtml(html) {
  if (typeof html !== 'string') {
    return '';
  }
  return sanitizeHtml(html, sanitizeHtmlOptions);
}
